














import { Vue, Component, Prop } from "vue-property-decorator";
import {
  COLOR_DRYING_PROGRESS_BAR_GREEN,
  COLOR_DRYING_PROGRESS_BAR_YELLOW,
  COLOR_DRYING_PROGRESS_BAR_RED,
  COLOR_DRYING_PROGRESS_BAR_GREY,
  COLOR_DRYING_PROGRESS_BAR_GREY_DARK,
} from "@/utils/colors";
import { themed } from "@/utils/Theme";
import {
  calculateDryingProgressPercent,
  DryingProjectOverview,
} from "@/data/models/DryingProjectOverview";
@Component
export default class DryingProgressComponent extends Vue {
  @Prop() readonly dryingProjectOverview!: DryingProjectOverview;

  backgroundColor = COLOR_DRYING_PROGRESS_BAR_GREY;
  color = COLOR_DRYING_PROGRESS_BAR_GREY;
  progress = 0;

  displayProgress = false;

  dryingTime = "";

  created() {
    const overview = this.dryingProjectOverview;
    const estimatedDryingDurationInDays = overview.estimatedDryingDurationInDays ??
      overview.dryingProjectSteps?.damageAssessmentResult?.estimatedDryingTime;

    const dryingStart = overview.setupDryingStartedBy?.recordedAt;
    const dryingEnd = overview.dryingEnd;

    if (!dryingStart || !!dryingEnd) {
      this.displayProgress = false;
    }

    if (estimatedDryingDurationInDays) {
      const dryingPercent = calculateDryingProgressPercent(overview);
      this.displayProgress = true;
      this.dryingTime = this.getDryingTimeString(
        estimatedDryingDurationInDays
      );

      if (dryingPercent <= 1.0) {
        this.progress = dryingPercent * 100;
        this.color = COLOR_DRYING_PROGRESS_BAR_GREEN;
      } else if (dryingPercent <= 2.0) {
        this.progress = (dryingPercent - 1.0) * 100;
        this.backgroundColor = COLOR_DRYING_PROGRESS_BAR_GREEN;
        this.color = COLOR_DRYING_PROGRESS_BAR_YELLOW;
      } else {
        this.progress = (dryingPercent - 2.0) * 100;
        this.backgroundColor = COLOR_DRYING_PROGRESS_BAR_YELLOW;
        this.color = COLOR_DRYING_PROGRESS_BAR_RED;
      }
    }
  }

  /**
   * The bar's track. Only the empty grey track is themed: once a drying runs over its estimate the
   * track carries the previous stage's colour, which is data and stays the same in both themes.
   * A getter rather than a field so a live theme switch repaints it.
   */
  get trackColor(): string {
    return this.backgroundColor === COLOR_DRYING_PROGRESS_BAR_GREY
      ? themed(COLOR_DRYING_PROGRESS_BAR_GREY, COLOR_DRYING_PROGRESS_BAR_GREY_DARK)
      : this.backgroundColor;
  }

  getDryingTimeString(timeInDays: number): string {
    if (this.dryingProjectOverview.dryingProjectSteps) {
      return "";
    }

    return this.$tc(
      "projectStatus.formatDryingDuration",
      timeInDays
    ).toString();
  }
}
